// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '14.0.0-beta.20260623.2306';
